import { TimeStepCumulativeRainfallDTO } from './TimeStepCumulativeRainfallDTO'

export class SnapshotCumulativeRainfallDTO {
  constructor(
    readonly city: string,
    readonly timestamp: string,
    readonly history: Array<TimeStepCumulativeRainfallDTO>,
    readonly reference: TimeStepCumulativeRainfallDTO,
    readonly forecasts: Array<TimeStepCumulativeRainfallDTO>,
  ) {}
}
